// This util creates a Strapi query string using dynamic columns
export function tableQueryBuilder({ page, pageSize, sort, search, filters, columns = [] }) {
  const params = new URLSearchParams();

  // Pagination
  if (page) params.append("pagination[page]", page);
  if (pageSize) params.append("pagination[pageSize]", pageSize);

  // Sorting
  if (sort && sort.field && sort.order) {
    params.append("sort", `${sort.field}:${sort.order}`);
  }

  // Dynamic search (for all columns marked as searchable)
  if (search && columns.length) {
    columns
      .filter(col => col.searchable)
      .forEach((col, idx) => {
        params.append(`filters[$or][${idx}][${col.field}][$contains]`, search);
      });
  }

  // Additional filters
  if (filters && typeof filters === "object") {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        params.append(`filters[${key}][$eq]`, value);
      }
    });
  }

  return params.toString();
}
